import { c as _c } from "react-compiler-runtime";
import React from "react";
import { FieldErrorContext, TextField as AriaTextField } from "react-aria-components";
import * as styles from "./Field.css.js";
import { InputSubtext } from "./InputSubtext.js";
import { Label } from "./Label.js";
import { FCTextFieldContext } from "./TextFieldContext.js";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const Description = t0 => {
  const $ = _c(12);
  const {
    description,
    textError
  } = t0;
  let t1;
  let t2;
  if ($[0] !== textError) {
    t2 = textError == null ? [] : [textError];
    $[0] = textError;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      customError: true,
      badInput: false,
      patternMismatch: false,
      rangeOverflow: false,
      rangeUnderflow: false,
      stepMismatch: false,
      tooLong: false,
      tooShort: false,
      typeMismatch: false,
      valid: false,
      valueMissing: false
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== t2) {
    t4 = {
      isInvalid: true,
      validationErrors: t2,
      validationDetails: t3
    };
    $[3] = t2;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  t1 = t4;
  const fieldErrorContextProps = t1;
  if (textError != null) {
    let t5;
    if ($[5] !== description) {
      t5 = /*#__PURE__*/_jsx(InputSubtext, {
        text: description
      });
      $[5] = description;
      $[6] = t5;
    } else {
      t5 = $[6];
    }
    let t6;
    if ($[7] !== fieldErrorContextProps || $[8] !== t5) {
      t6 = /*#__PURE__*/_jsx(FieldErrorContext.Provider, {
        value: fieldErrorContextProps,
        children: t5
      });
      $[7] = fieldErrorContextProps;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  let t5;
  if ($[10] !== description) {
    t5 = /*#__PURE__*/_jsx(InputSubtext, {
      text: description
    });
    $[10] = description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
const BaseTextField = (t0, ref) => {
  const $ = _c(23);
  let children;
  let description;
  let label;
  let labelTooltip;
  let props;
  let t1;
  let validate;
  if ($[0] !== t0) {
    ({
      label,
      labelTooltip,
      description,
      orientation: t1,
      children,
      validate,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = description;
    $[3] = label;
    $[4] = labelTooltip;
    $[5] = props;
    $[6] = t1;
    $[7] = validate;
  } else {
    children = $[1];
    description = $[2];
    label = $[3];
    labelTooltip = $[4];
    props = $[5];
    t1 = $[6];
    validate = $[7];
  }
  const orientation = t1 === undefined ? "vertical" : t1;
  const textError = props.isInvalid === true && typeof validate === "string" ? validate : undefined;
  const ariaValidate = typeof validate === "function" ? validate : undefined;
  const labelRef = React.useRef(null);
  let t2;
  if ($[8] !== orientation) {
    t2 = styles.base({
      orientation
    });
    $[8] = orientation;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  let t3;
  if ($[10] !== children || $[11] !== description || $[12] !== label || $[13] !== labelTooltip || $[14] !== textError || $[15] !== validate) {
    t3 = innerProps => /*#__PURE__*/_jsxs(_Fragment, {
      children: [label != null && /*#__PURE__*/_jsx("div", {
        className: styles.label,
        children: /*#__PURE__*/_jsx(Label, {
          ref: labelRef,
          tooltip: labelTooltip,
          children: label
        })
      }), /*#__PURE__*/_jsx(FCTextFieldContext.Provider, {
        value: {
          label,
          labelTooltip,
          description,
          validate,
          labelRef
        },
        children: /*#__PURE__*/_jsx("div", {
          className: styles.children,
          children: typeof children === "function" ? children(innerProps) : children
        })
      }), (description != null || textError != null || innerProps.isInvalid) && /*#__PURE__*/_jsx("div", {
        className: styles.description,
        children: /*#__PURE__*/_jsx(Description, {
          description: description,
          textError: textError
        })
      })]
    });
    $[10] = children;
    $[11] = description;
    $[12] = label;
    $[13] = labelTooltip;
    $[14] = textError;
    $[15] = validate;
    $[16] = t3;
  } else {
    t3 = $[16];
  }
  let t4;
  if ($[17] !== ariaValidate || $[18] !== props || $[19] !== ref || $[20] !== t2 || $[21] !== t3) {
    t4 = /*#__PURE__*/_jsx(AriaTextField, {
      ...props,
      validate: ariaValidate,
      ref: ref,
      className: t2,
      children: t3
    });
    $[17] = ariaValidate;
    $[18] = props;
    $[19] = ref;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  return t4;
};
export const Field = /*#__PURE__*/React.forwardRef(BaseTextField);
//# sourceMappingURL=Field.js.map